import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";
import { EASE_CALM } from "../../lib/motion";

type TDelayedEnterProps = {
	children: ReactNode;
	className?: string;
	delayMs: number;
	durationMs: number;
	enabled: boolean;
	/** Drives the stagger animation while the step intro is playing. */
	playing: boolean;
	/** Keeps the element visible after the intro completes (matches prior CSS `complete` state). */
	visible: boolean;
};

export function DelayedEnter({
	children,
	className,
	delayMs,
	durationMs,
	enabled,
	playing,
	visible,
}: TDelayedEnterProps) {
	const reducedMotion = useReducedMotion();
	const hidden = { opacity: 0, y: 14 };
	const shown = { opacity: 1, y: 0 };
	/* Always the same motion host. Switching to a plain div when `enabled` flips
	   remounts children — and the landing robot replays its intro spin. */
	const skipMotion = !enabled || Boolean(reducedMotion);

	return (
		<motion.div
			className={className}
			initial={skipMotion ? shown : hidden}
			animate={skipMotion || visible ? shown : hidden}
			transition={
				skipMotion || !playing
					? { duration: 0 }
					: { duration: durationMs / 1000, delay: delayMs / 1000, ease: EASE_CALM }
			}
		>
			{children}
		</motion.div>
	);
}
